import Glider from 'glider-js';
import { MQ } from '../tools/MQ.js';

export const init = () => {
	const carousel = document.querySelectorAll('.js-steps-carousel');
	if (!carousel) return;
	const jsArrowsPrev = Array.from(document.querySelectorAll('.js-carousel-prev'));
	const jsArrowsNext = Array.from(document.querySelectorAll('.js-carousel-next'));

	Array.from(carousel).forEach((item, index) => {
		new Glider(item, {
			slidesToShow: 1,
			slidesToScroll: 1,
			scrollLock: true,

			draggable: true,
			dots: item.nextElementSibling,
			arrows: false,
			responsive: [
				{
					breakpoint: 1000,
					settings: {
						dots: false,
						arrows: {
							prev: jsArrowsPrev[index],
							next: jsArrowsNext[index],
						},
						slidesToShow: 3,
						slidesToScroll: 'auto',
						draggable: false,
					},
				},
			],
		});
	});
};
